import { API_ROOT } from 'environment';

angular.module('app.resources').factory('Origin', ($q, $resource) => {

  var Origin = $resource(`${API_ROOT}/origins/:id`, { id: '@id' }, {
      get: {
          method: 'GET'
      },
      drain: {
          method: 'POST',
          url: `${API_ROOT}/origins/:id/drain`
      },
      terminate: {
          method: 'POST',
          url: `${API_ROOT}/origins/:id/delete`
      },
  });

  return Origin;
}
);


// WEBPACK FOOTER //
// ./resources/origin.js